import CounterStyle from '../CounterStyle';

const lowerAlpha = CounterStyle.alphabeticFromUnicodeRange(97, 26);

export default lowerAlpha;
